module.exports = __webpack_public_path__ + "img/bg-type01-pc.48336192.png";